import React, { useState, useEffect } from "react";
import "./Admin.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Admin = () => {
  const [certificates, setCertificates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formLoading, setFormLoading] = useState(false);

  const [formData, setFormData] = useState({
    certId: "",
    name: "",
    program: "",
    course: "",
    year: "",
    term: "Long",
    status: "COMPLETED",
    college: "",
    council: "Andhra Pradesh",
    issueDate: "",
    remarks: ""
  });

  const [editId, setEditId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  // API Base URL - change this based on environment
 const API_BASE_URL = "https://www.talenttrektechnologies.com/certificate-backend";
  useEffect(() => {
    fetchCertificates();
  }, []);

  const fetchCertificates = async () => {
    setLoading(true);
    try {
      const url = `${API_BASE_URL}/api/certificates.php`;
      console.log("Fetching from:", url);
      
      const res = await fetch(url, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
        }
      });
      
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }
      
      const data = await res.json();
      console.log("Fetched data:", data);
      
      if (data.error) {
        toast.error(data.error);
        setCertificates([]);
      } else {
        setCertificates(Array.isArray(data) ? data : []);
        toast.success(`Loaded ${Array.isArray(data) ? data.length : 0} certificates`);
      }
    } catch (err) {
      console.error("Fetch error details:", err);
      
      // Specific error messages based on error type
      if (err.message.includes('CORS') || err.message.includes('fetch')) {
        toast.error("❌ CORS Error: Backend not configured to accept requests from this domain. Please check backend CORS settings.");
        console.error("CORS Error - Make sure backend has proper headers");
      } else if (err.message.includes('Failed to fetch')) {
        toast.error("❌ Network Error: Cannot connect to server. Check if backend is running and accessible.");
      } else {
        toast.error(`❌ Error fetching data: ${err.message}`);
      }
      
      setCertificates([]);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormLoading(true);

    try {
      let url;
      let body;

      if (editId) {
        url = `${API_BASE_URL}/api/update.php`;
        body = JSON.stringify({
          id: editId,
          name: formData.name,
          program: formData.program,
          course: formData.course,
          year: formData.year,
          term: formData.term,
          status: formData.status,
          college: formData.college,
          council: formData.council,
          issue_date: formData.issueDate,
          remarks: formData.remarks
        });
      } else {
        url = `${API_BASE_URL}/api/certificates.php`;
        body = JSON.stringify({
          id: formData.certId,
          name: formData.name,
          program: formData.program,
          course: formData.course,
          year: formData.year,
          term: formData.term,
          status: formData.status,
          college: formData.college,
          council: formData.council,
          issue_date: formData.issueDate,
          remarks: formData.remarks
        });
      }

      console.log("Sending request to:", url);
      console.log("Request body:", body);

      const response = await fetch(url, {
        method: "POST",
        headers: { 
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: body
      });

      console.log("Response status:", response.status);
      
      // Try to parse response even if not OK
      let result;
      const responseText = await response.text();
      console.log("Raw response:", responseText);
      
      try {
        result = JSON.parse(responseText);
      } catch (e) {
        result = { message: responseText };
      }

   if (response.ok && result.success) {
  if (editId) {
    toast.success("✅ Certificate updated successfully!");
  } else {
    toast.success("✅ Certificate added successfully!");
  }

  // reset form
  setFormData({
    certId: "",
    name: "",
    program: "",
    course: "",
    year: "",
    term: "Long",
    status: "COMPLETED",
    college: "",
    council: "Andhra Pradesh",
    issueDate: "",
    remarks: ""
  });

  setEditId(null);
  await fetchCertificates();

} else {
  const msg = result.message?.toLowerCase() || "";

  if (msg.includes("duplicate")) {
    toast.error("❌ Already a certificate with this ID");
  } else {
    toast.error(`❌ ${result.message || "Something went wrong"}`);
  }
}

    } catch (err) {
      console.error("Submit error details:", err);
      
      if (err.message.includes('CORS')) {
        toast.error("❌ CORS Error: Backend not accepting requests. Please check server configuration.");
      } else if (err.message.includes('Failed to fetch')) {
        toast.error("❌ Network Error: Cannot reach the server. Please check if the backend URL is correct and the server is running.");
      } else {
        toast.error(`❌ Error: ${err.message}`);
      }
    } finally {
      setFormLoading(false);
    }
  };

  const handleEdit = (cert) => {
    setFormData({
      certId: cert.id,
      name: cert.name,
      program: cert.program,
     course: cert.course || "",
      year: cert.year,
      term: cert.term || "Long",
      status: cert.status,
      college: cert.college || "",
      council: cert.council || "Andhra Pradesh",
      issueDate: cert.issue_date ? cert.issue_date.split("T")[0] : "",
      remarks: cert.remarks || ""
    });
    setEditId(cert.id);
    toast.info("✏️ Edit mode: Update the certificate details and submit");
  };

  const handleDelete = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    setFormLoading(true);
    try {
      const url = `${API_BASE_URL}/api/delete.php?id=${deleteId}`;
      const response = await fetch(url);
      const result = await response.json();
      
      if (response.ok && (result.success === true || result.message?.includes("success"))) {
        toast.success("🗑️ Certificate deleted successfully!");
        await fetchCertificates();
        setShowDeleteModal(false);
      } else {
        const errorMsg = result.message || result.error || "Delete failed";
        toast.error(`❌ Delete failed: ${errorMsg}`);
      }
    } catch (err) {
      console.error("Delete error:", err);
      toast.error("❌ Network error while deleting!");
    } finally {
      setFormLoading(false);
    }
  };

  const cancelEdit = () => {
    setEditId(null);
    setFormData({
      certId: "",
      name: "",
      program: "",
      course: "",
      year: "",
      term: "Long",
      status: "COMPLETED",
      college: "",
      council: "Andhra Pradesh",
      issueDate: "",
      remarks: ""
    });
    toast.info("Edit mode cancelled");
  };
const toggleActive = async (cert) => {
  try {
    const newActive = cert.is_active == 1 ? 0 : 1;

    const response = await fetch(
      `${API_BASE_URL}/api/update.php`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: cert.id,
          name: cert.name,
          program: cert.program,
          course: cert.course,
          year: cert.year,
          term: cert.term,
          status: cert.status, // 🔴 unchanged
          college: cert.college,
          council: cert.council,
          issue_date: cert.issue_date,
          remarks: cert.remarks,
          is_active: newActive   // ✅ NEW FIELD
        }),
      }
    );

    const result = await response.json();

    if (result.success) {
      toast.success(newActive ? "Activated" : "Deactivated");
      fetchCertificates();
    } else {
      toast.error("Failed to update");
    }
  } catch (err) {
    toast.error("Error updating");
  }
};
  return (
    <div className="admin-panel">
      <ToastContainer 
        position="top-right" 
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        pauseOnHover
      />

      <h1>Admin Panel - 1</h1>

      <form onSubmit={handleSubmit} className="admin-form">
        <input 
          name="certId" 
          placeholder="Certificate ID" 
          value={formData.certId} 
          onChange={handleChange} 
          required 
          disabled={editId !== null}
          title={editId ? "Certificate ID cannot be changed in edit mode" : ""}
        />
        <input name="name" placeholder="Student Name" value={formData.name} onChange={handleChange} required />
        <input name="college" placeholder="College Name" value={formData.college} onChange={handleChange} required />
      <select name="program" value={formData.program} onChange={handleChange} required>
  <option value="">Select Program</option>
  <option value="Internship">Internship</option>
  <option value="Training">Training</option>
  <option value="Hackathon">Hackathon</option>
  <option value="Codeathon">Codeathon</option>
  <option value="Ideathon">Ideathon</option>
</select>

{/* 👇 NEW FIELD (separate) */}
<input 
  name="course" 
  placeholder="Course" 
 value={formData.course || ""} 
  onChange={handleChange} 
  required 
/>
        <input name="year" placeholder="Year Duration" value={formData.year} onChange={handleChange} required />

        <select name="term" value={formData.term} onChange={handleChange}>
          <option value="Long">Long Term</option>
          <option value="Short">Short Term</option>
        </select>

        <input type="date" name="issueDate" value={formData.issueDate} onChange={handleChange} required />

        <select name="council" value={formData.council} onChange={handleChange}>
          <option value="Andhra Pradesh">Andhra Pradesh</option>
          <option value="Telangana">Telangana</option>
          <option value="Karnataka">Karnataka</option>
          <option value="Tamil Nadu">Tamil Nadu</option>
        </select>

        <select name="status" value={formData.status} onChange={handleChange}>
          <option value="COMPLETED">Completed</option>
          <option value="PENDING">Pending</option>
        </select>

        <input
          type="text"
          placeholder="Remarks"
          value={formData.remarks}
          onChange={(e) => setFormData({ ...formData, remarks: e.target.value })}
        />

        <div className="form-buttons">
          <button type="submit" disabled={formLoading}>
            {formLoading ? "Processing..." : (editId ? "Update Certificate" : "Add Certificate")}
          </button>
          
          {editId && (
            <button type="button" onClick={cancelEdit} className="cancel-btn">
              Cancel Edit
            </button>
          )}
        </div>
      </form>

      <h2>Certificates List</h2>
      {loading ? (
        <div className="loading">Loading certificates...</div>
      ) : (
        <div className="table-container">
          <table className="certificates-table">
            <thead>
              <tr>
                <th>ID</th><th>Name</th><th>College</th><th>Program</th> <th>Course</th>
                <th>Year</th><th>Term</th><th>Council</th>
                <th>Issue Date</th><th>Status</th><th>Remarks</th><th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {certificates.length === 0 ? (
                <tr>
                  <td colSpan="11" style={{ textAlign: "center" }}>
                    No certificates found
                  </td>
                </tr>
              ) : (
                certificates.map((cert) => (
                  <tr key={cert.id}>
                    <td>{cert.id}</td>
                    <td>{cert.name}</td>
                    <td>{cert.college}</td>
                    <td>{cert.program}</td>
                    <td>{cert.course}</td>
                    <td>{cert.year}</td>
                    <td>{cert.term}</td>
                    <td>{cert.council}</td>
                    <td>{cert.issue_date}</td>
                    <td>
                      <span className={`status-badge ${cert.status === "COMPLETED" ? "status-completed" : "status-pending"}`}>
                        {cert.status}
                      </span>
                    </td>
                    <td>{cert.remarks || "-"}</td>
                    <td className="action-buttons">
  {/* Edit */}
  <button 
    onClick={() => handleEdit(cert)} 
    className="edit-btn"
  >
    Edit
  </button>

 <button
  onClick={() => toggleActive(cert)}
  className={cert.is_active == 1 ? "deactivate-btn" : "activate-btn"}
>
  {cert.is_active == 1 ? "Deactivate" : "Activate"}
</button>

  {/* Download */} 
  <a
    href={`${API_BASE_URL}/api/download.php?id=${cert.id}`}
    target="_blank"
    rel="noreferrer"
    className="download-link"
  > 
    Download
  </a>
  
</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}

      
      
    </div>
  );
};

export default Admin;